// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  height: 100%;
  margin: 20px;
  min-width: 295px;
  max-width: 360px;
  border-radius: 20px !important;
  border-color: rgb(68,68,68);
  margin: auto;
  background: none;
}

.cardContent {
  font-weight: bolder;
  padding: 20px 0px 20px 35px !important;
  border-radius: 200px;
}

.heading {
  font-weight: 600 !important;
  height: 50%;
}

.card-body {
  font-weight: 600 !important;
  color: gray;
  font-size: 18px !important;
  margin: auto !important;
}

.card-button {
  padding: 6px 18px !important;
  font-size: 18px !important;
  font-weight: bolder !important;
  border-radius: 10px !important;
}

.shadow {  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */  /* Firefox 3.5 - 3.6 */
  box-shadow:         3px 3px 5px 6px #ccc;  /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */
}

.shadow1 {
  box-shadow: 5px 5px 5px rgba(68, 68, 68, 0.6);

  filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=3,MakeShadow=true,ShadowOpacity=0.30);
  -ms-filter: "progid:DXImageTransform.Microsoft.Blur(PixelRadius=3,MakeShadow=true,ShadowOpacity=0.30)";
  zoom: 1;
}
.shadow1 .content {
  position: relative; /* This protects the inner element from being blurred */
  padding: 100px;
  background-color: #DDD;
}

.one-edge-shadow {
    box-shadow: 0 8px 6px -6px black;
}`, "",{"version":3,"sources":["webpack://./src/styles/CaseCard.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,WAC6C,8CAA8C,GAC9C,sBAAsB;EACjE,wCAAwC,GAAG,mDAAmD;AAChG;;AAEA;EAIE,6CAA6C;;EAE7C,gGAAgG;EAChG,sGAAsG;EACtG,OAAO;AACT;AACA;EACE,kBAAkB,EAAE,uDAAuD;EAC3E,cAAc;EACd,sBAAsB;AACxB;;AAEA;IAGY,gCAAgC;AAC5C","sourcesContent":[".card {\n  height: 100%;\n  margin: 20px;\n  min-width: 295px;\n  max-width: 360px;\n  border-radius: 20px !important;\n  border-color: rgb(68,68,68);\n  margin: auto;\n  background: none;\n}\n\n.cardContent {\n  font-weight: bolder;\n  padding: 20px 0px 20px 35px !important;\n  border-radius: 200px;\n}\n\n.heading {\n  font-weight: 600 !important;\n  height: 50%;\n}\n\n.card-body {\n  font-weight: 600 !important;\n  color: gray;\n  font-size: 18px !important;\n  margin: auto !important;\n}\n\n.card-button {\n  padding: 6px 18px !important;\n  font-size: 18px !important;\n  font-weight: bolder !important;\n  border-radius: 10px !important;\n}\n\n.shadow { \n  -webkit-box-shadow: 3px 3px 5px 6px #ccc;  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */\n  -moz-box-shadow:    3px 3px 5px 6px #ccc;  /* Firefox 3.5 - 3.6 */\n  box-shadow:         3px 3px 5px 6px #ccc;  /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */\n}\n\n.shadow1 {\n\n  -moz-box-shadow: 5px 5px 5px rgba(68, 68, 68, 0.6);\n  -webkit-box-shadow: 5px 5px 5px rgba(68, 68, 68, 0.6);\n  box-shadow: 5px 5px 5px rgba(68, 68, 68, 0.6);\n\n  filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=3,MakeShadow=true,ShadowOpacity=0.30);\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Blur(PixelRadius=3,MakeShadow=true,ShadowOpacity=0.30)\";\n  zoom: 1;\n}\n.shadow1 .content {\n  position: relative; /* This protects the inner element from being blurred */\n  padding: 100px;\n  background-color: #DDD;\n}\n\n.one-edge-shadow {\n    -webkit-box-shadow: 0 8px 6px -6px black;\n       -moz-box-shadow: 0 8px 6px -6px black;\n            box-shadow: 0 8px 6px -6px black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
